// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FundModelResponseFromJSON(json) {
    return {
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'investorAccountId': !exists(json, 'investorAccountId') ? undefined : json['investorAccountId'],
        'cashflowModelId': !exists(json, 'cashflowModelId') ? undefined : json['cashflowModelId'],
        'isPredefined': !exists(json, 'isPredefined') ? undefined : json['isPredefined'],
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
    };
}
export function FundModelResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'requestId': value.requestId,
        'fundId': value.fundId,
        'investorAccountId': value.investorAccountId,
        'cashflowModelId': value.cashflowModelId,
        'isPredefined': value.isPredefined,
        'isDefault': value.isDefault,
    };
}
